import JadMage1 from "../../assets/images/jad/jad_mage_1.png";
import JadMage2 from "../../assets/images/jad/jad_mage_2.png";
import JadMage3 from "../../assets/images/jad/jad_mage_3.png";
import JadMage4 from "../../assets/images/jad/jad_mage_4.png";
import JadMage5 from "../../assets/images/jad/jad_mage_5.png";
import JadMage6 from "../../assets/images/jad/jad_mage_6.png";
import JadMage7 from "../../assets/images/jad/jad_mage_7.png";
import JadMage8 from "../../assets/images/jad/jad_mage_8.png";
import JadMage9 from "../../assets/images/jad/jad_mage_9.png";
import JadMage10 from "../../assets/images/jad/jad_mage_10.png";
import JadMage11 from "../../assets/images/jad/jad_mage_11.png";
import JadMage12 from "../../assets/images/jad/jad_mage_12.png";
import JadMage13 from "../../assets/images/jad/jad_mage_13.png";
import JadMage14 from "../../assets/images/jad/jad_mage_14.png";
import JadMage15 from "../../assets/images/jad/jad_mage_15.png";
import JadMage16 from "../../assets/images/jad/jad_mage_16.png";
import JadMage17 from "../../assets/images/jad/jad_mage_17.png";
import JadMage18 from "../../assets/images/jad/jad_mage_18.png";
import JadMage19 from "../../assets/images/jad/jad_mage_19.png";
import JadMage20 from "../../assets/images/jad/jad_mage_20.png";
import JadMage21 from "../../assets/images/jad/jad_mage_21.png";
import JadMage22 from "../../assets/images/jad/jad_mage_22.png";
import JadMage23 from "../../assets/images/jad/jad_mage_23.png";
import JadMage24 from "../../assets/images/jad/jad_mage_24.png";
import JadMage25 from "../../assets/images/jad/jad_mage_25.png";
import JadMage26 from "../../assets/images/jad/jad_mage_26.png";
import JadMage27 from "../../assets/images/jad/jad_mage_27.png";
import JadMage28 from "../../assets/images/jad/jad_mage_28.png";
import JadMage29 from "../../assets/images/jad/jad_mage_29.png";
import JadMage30 from "../../assets/images/jad/jad_mage_30.png";
import JadMage31 from "../../assets/images/jad/jad_mage_31.png";
import JadMage32 from "../../assets/images/jad/jad_mage_32.png";

import JadRange1 from "../../assets/images/jad/jad_range_1.png";
import JadRange2 from "../../assets/images/jad/jad_range_2.png";
import JadRange3 from "../../assets/images/jad/jad_range_3.png";
import JadRange4 from "../../assets/images/jad/jad_range_4.png";
import JadRange5 from "../../assets/images/jad/jad_range_5.png";
import JadRange6 from "../../assets/images/jad/jad_range_6.png";
import JadRange7 from "../../assets/images/jad/jad_range_7.png";
import JadRange8 from "../../assets/images/jad/jad_range_8.png";
import JadRange9 from "../../assets/images/jad/jad_range_9.png";
import JadRange10 from "../../assets/images/jad/jad_range_10.png";
import JadRange11 from "../../assets/images/jad/jad_range_11.png";
import JadRange12 from "../../assets/images/jad/jad_range_12.png";
import JadRange13 from "../../assets/images/jad/jad_range_13.png";

// These were captured at 10fps
export const JAD_FRAMES_PER_TICK = 6;

export const JAD_MAGE_FRAMES = [
  JadMage1,
  JadMage2,
  JadMage3,
  JadMage4,
  JadMage5,
  JadMage6,
  JadMage7,
  JadMage8,
  JadMage9,
  JadMage10,
  JadMage11,
  JadMage12,
  JadMage13,
  JadMage14,
  JadMage15,
  JadMage16,
  JadMage17,
  JadMage18,
  JadMage19,
  JadMage20,
  JadMage21,
  JadMage22,
  JadMage23,
  JadMage24,
  JadMage25,
  JadMage26,
  JadMage27,
  JadMage28,
  JadMage29,
  JadMage30,
  JadMage31,
  JadMage32,
];

export const JAD_RANGE_FRAMES = [
  JadRange1,
  JadRange2,
  JadRange3,
  JadRange4,
  JadRange5,
  JadRange6,
  JadRange7,
  JadRange8,
  JadRange9,
  JadRange10,
  JadRange11,
  JadRange12,
  JadRange13,
];
